<template>
  <div class="content-max-width flex flex-between">
    <product-filters 
      :categories="categories" 
    ></product-filters>

    <div class="product-list">
      <div class="result-filter flex flex-between align-center">
        <p v-if="keyword">
          Showing results for <strong>"{{ keyword }}"</strong>
        </p>

        <div class="select-wrap">
          <label>Sort by</label>
          <select
            v-model="sortOrder"
            @change="setPage(1)"
          >
            <option
              v-for="(option, index) in sortOptions"
              :key="index"
              :value="option.value"
            >
              <span>{{ option.label }}</span>
            </option>
          </select>
        </div>
      </div>

      <div class="products flex flex-between align-stretch">
        <product-item
          v-for="p in pinProducts"
          :key="p.id"
          :product="p"
        ></product-item>
        <product-item
          v-for="p in noPinProducts"
          :key="p.id"
          :product="p"
        ></product-item>
        <div v-if="products.length == 0">No Products Found</div>
      </div>

      <app-pagination 
        v-if="products.length"
        :pagination="pagination"
        v-on:setPage="setPage"
        v-on:setPerPage="setPerPage"
      ></app-pagination>

      <div class="wysywig category-main-description" v-if="category" v-html="category.description"></div>
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    category: Object,
    categories: Array,
    search: String
  },

  data () {
    return {
      products: [],
      pinProducts: [],
      noPinProducts: [],
      sortOrder: 'a-z',
      keyword: this.search,
      sortOptions: [
        { label: 'A-Z', value: 'a-z'},
        { label: 'Z-A', value: 'z-a'},
        { label: 'Lowest Price', value: 'lowest'},
        { label: 'Highest Price', value: 'highest'},
      ],
      pagination: {
        current_page: 1,
        from: 1,
        last_page: 1,		    
        per_page: 16,
        to: 1,
        total: 0,
      }
    }
  },

  mounted () {
    // console.log(this.category)

    if(this.search && ['filter','filters'].indexOf(this.search.toLowerCase()) != -1) {
       this.sortOrder = 'z-a'
    }

    this.loadProducts()
  },

  methods: {
    setPage (page) {
      this.pagination.current_page = page
      this.loadProducts()
    },

    setPerPage (per) {
      this.pagination.per_page = per
      this.loadProducts()
    },

    loadProducts () {
      let url = '/api/products?page=' + this.pagination.current_page
      
      if (this.category) {
        url += '&category_ids[]=' + this.category.id
      } else {
        if (this.keyword) {
          url += '&keyword=' + this.keyword
        }
      }

      url += '&sortby=' + this.sortOrder
      
      url += '&per_page=' + this.pagination.per_page
      
      this.$store.commit('setLoading', true)
      
      window.axios.get(url)
        .then(response => {
          this.noPinProducts = []
          // this.pinProducts = []
          this.products = response.data.data
          this.pagination = response.data.meta
          
          this.products.forEach(el => {
            if(el.pin == 1) {
              let checkPin = this.products.filter((item) => item.id == el.id)
              if(checkPin.length == 0 || this.pinProducts.length == 0) {
                this.pinProducts.push(el)
              }
            } else {
              this.noPinProducts.push(el)
            }
          });
          
          this.$store.commit('setLoading', false)
        })
    }
  },
}
</script>

<style scoped>
.wysywig {
  margin: 50px 0 0;
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-product/Index.vue